import type { AccessTokenData } from '@empathyco/playboard-core-domain'
import type { AuthTokenService } from './interfaces'
import { getIamAccessTokenData } from '@empathyco/playboard-core-domain'

export class IamAuthTokenService implements AuthTokenService {
  getInfo(token: string): AccessTokenData {
    return getIamAccessTokenData(token)
  }

  isExpired(token: string): boolean {
    return this.getInfo(token).expirationDate.getTime() <= Date.now()
  }

  isNearToExpire(token: string, marginInMillis: number): boolean {
    const expirationDateInMillis = this.getInfo(token).expirationDate.getTime()
    const now = Date.now()
    return expirationDateInMillis > now && expirationDateInMillis < now + marginInMillis
  }
}
